// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gUPZ2","col":"styles_col__2VPjx"};